import * as Yup from 'yup';

export const editEmployeeFormSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  userName: Yup.string().required('Username is required'),
  // userRoles: Yup.object().required('Role is required'),
  userRoles: Yup.array()
    .nullable() // Allows undefined or null initially
    .required('Role is required') // Throws an error if userRoles is undefined
    .min(1, 'Role is required'),
  email: Yup.string().email('Invalid email').required('Contact email is required'),
  fastFieldEmailID: Yup.string().email('Invalid email').notRequired(),
  // mobile: Yup.string()
  //   .nullable() // Allows undefined or null initially
  //   .when('isDuxEnable', {
  //     is: true, // When `isDuxEnable` is true
  //     then: (schema) => schema.required('Contact phone is required').matches(/^[0-9]{10}$/, 'Invalid phone number'),
  //     otherwise: (schema) => schema.notRequired(), // Not required when `isDuxEnable` is false
  //   }),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, { excludeEmptyString: true, message: 'Invalid phone number' })
    .required('Contact phone number is required'),
});
